import React, { Component } from 'react';
import Navbar from "../../Navbar";
import Footer from "../../Footer";

class Projects extends Component {
    render() {
        return (
            <div style={{color: "white"}}>
                <Navbar />
                projects
                <Footer />
            </div>
        )
    }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/App/routes/Projects/index.js